import { useTranslation } from "@refinedev/core";
import { IEInvoiceItem } from "interfaces";
import moment from "moment";
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import { Tag } from "components/tag";
import {
  capitalizeFirstLetter,
  formatNumber,
  getFormattedDate,
} from "utills/helpers";

interface EInvoiceCardProps {
  data?: IEInvoiceItem[];
  pageSize: number;
  currentPage: number;
}

export const EInvoiceCard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
}: EInvoiceCardProps) => {
  const { translate } = useTranslation();

  return (
    <ul className="bg-white">
      {data.map((invoice, index) => (
        <div
          key={invoice.reference_code}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <div className="w-full flex items-center justify-between">
            <Tag
              text={capitalizeFirstLetter(invoice.status)}
              type={
                invoice.status === "issued" || invoice.status === "signed"
                  ? "green"
                  : invoice.status === "draft"
                    ? "yellow"
                    : invoice.status === "cancelled"
                      ? "pink"
                      : "blue"
              }
            />
            {invoice.pdf_url && (
              <a
                href={invoice.pdf_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-500 hover:text-brand-700"
              >
                <DocumentDownloadIcon className="w-5 h-5" />
              </a>
            )}
          </div>

          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">{translate("no")}</p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              {translate("einvoice-no")}
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {invoice.invoice_series}-{invoice.invoice_number}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              {translate("einvoice-date")}
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {invoice.issued_date
                ? getFormattedDate(invoice.issued_date)
                : "-"}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              {translate("einvoice-buyer-name")}
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {invoice.buyer?.name ?? "-"}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              {translate("einvoice-total")}
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {invoice.total_amount != null
                ? formatNumber(invoice.total_amount)
                : "-"}
            </p>
          </li>
        </div>
      ))}
    </ul>
  );
};
